import { placeholder } from '@mapbox/mapbox-gl-geocoder/lib/localization'

const lang = {
  page_title: '林地情報',
  breadcrumb: {
    list: '林地情報',
  },
  button: {
    create_project: 'プロジェクト作成',
    create_forest_management_plans: '森林経営計画書追加',
  },
  select_single: {
    title: '林地の色',
  },
  create_management_plans_modal: {
    title: '森林経営計画書の追加',
    name: '森林経営計画名',
    management_plan_csv: '森林経営計画ファイル',
    cert_number: '認定番号',
    cert_date: '認定日',
    planning_period: '計画期間',
    forest_age_base_year: '林齢の基準年度',
    planning_area: '計画面積',
    planning_start: '計画開始：',
    planning_end: '計画終了：',
    shape_file: 'shapeファイル',
    placeholder: {
      name: '森林経営計画名を入力',
      cert_number: '認定番号を入力',
      forest_age_base_year: '例: 2018',
      planning_area: '計画面積を入力',
    },
  },
  edit_management_plans_modal: {
    title: '森林経営計画書の編集',
    button: {
      delete: '森林経営計画を削除',
    },
    confirm_delete_modal: {
      title: '森林経営計画情報の削除',
      explain: '削除する場合は、以下のボックスに「削除」と入力した上で削除ボタンを選択してください。',
    },
  },
  table: {
    no_data_massage: '森林経営計画を選択してください。',
    no: 'No',
    name: '森林経営計画',
    forest_group: '林班',
    small_forest_group: '小班',
    small_forest_group_number: '小班番号',
    branch_group: '小班枝番',
    area: '面積',
    tree_species: '樹種',
    forest_age: '林齢',
    forest_type: '林種',
    restricted_type: '制限種別',
    position: '地位',
    thinning_year: '伐採年',
    thinning_area: '伐採面積',
    main_cutting_year: '主伐年',
    main_cutting_area: '主伐面積',
    afforestation_history_year: '造林年',
    afforestation_history_area: '造林面積',
    childcare_history_year: '育林年',
    childcare_history_area: '育林面積',
    cutting_planned_year: '伐採計画年',
    logging_method: '伐採計画主伐間伐別',
    cutting_planned_area: '伐採計画面積',
    afforestation_plan_year: '造林計画年',
    afforestation_plan_tree_species: '造林計画樹種',
    afforestation_plan_area: '造林計画面積',
    childcare_plan_year: '育林計画年',
    childcare_plan_area: '育林計画面積',
    prefecture: '都道府県',
    city: '市区郡',
    city_large_letter: '市区郡大字',
    house_number: '丁目番地',
    logging_method: '伐採計主伐間伐別',
  },
}

export default lang
